import React, { useContext, useEffect, useRef, useState } from "react";
import { Alert, Text } from "react-native";
import {
  ImageBackground,
  PixelRatio,
  ScrollView,
  StatusBar,
  TouchableOpacity,
  View,
  ViewStyle,
  StyleSheet,
  useWindowDimensions,
  Dimensions,
  Platform,
} from "react-native";
import { ThemeContext } from "../../config";
import {
  BgLandscapePng,
  BgPortraitPng,
  BgTournament,
  BgTournamentMobile,
} from "../../assets";
import { BottomSection, Sidebar, TopSection } from "../Components";
import { isFactorTv, isWebBased } from "@rnv/renative";
import BonusGamesModal from "../Components/Modals/BonusGamesComponents/BonusGamesModal";
import { useDevice } from "../../utils/hooks/useDevice";
import { usePaymentStatus } from "../../utils/hooks/paymentStatus";
import { PaymentStatusModal } from "../Components/Modals/PaymentStatusModal";
import { useSelector } from "react-redux";
import { getSocket } from "../../services/socket";
import { useNavigation, useNavigationState } from "@react-navigation/native";
import { GameRecoveryModal } from "../Components/Modals/GameRecoveryModal";
import {
  useSafeAreaInsets,
  SafeAreaView,
} from "react-native-safe-area-context";

type MainLayoutProps = {
  children: React.ReactNode;
};

export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const buttonRef = useRef<TouchableOpacity>(null);
  const { theme, dark } = useContext(ThemeContext);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isBonusGamesModalOpen, setIsBonusGamesModalOpen] = useState(false);
  const { width, height } = useWindowDimensions();
  const [showRecoveryModal, setShowRecoveryModal] = useState(false);
  const [recoveryData, setRecoveryData] = useState<any>(null);
  const paymentData = usePaymentStatus();
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const navigation = useNavigation();
  const auth = useSelector((s: any) => s.auth);
  const playerId = auth?.user?.id || "";
  const username = auth?.user?.username || "";
  // const width = Dimensions.get("window").width;
  // const height = Dimensions.get("window").height;
  const { isXLg } = useDevice();
  const isDesktop = width >= 980;
  const contentMinHeight = isXLg
    ? height * 0.75
    : isDesktop
      ? height * 0.68
      : undefined;
  // console.log("in the main page");
  const isTallScreen = height > 700;

  const isAndroid = Platform.OS === "android";
  console.log("⚠️ Using MainLayout.tsx (web) - Platform:", Platform.OS);

  useEffect(() => {
    if (paymentData.status) {
      setShowPaymentModal(true);
    }
  }, [paymentData.status]);

  useEffect(() => {
    PixelRatio.get();
    PixelRatio.getFontScale();
    if (isWebBased && isFactorTv && buttonRef?.current)
      buttonRef.current.focus();
  }, []);

  useEffect(() => {
    if (Platform.OS === "web") {
      const html = document.documentElement;
      const body = document.body;

      const prevHtmlH = html.style.height;
      const prevBodyH = body.style.height;
      const prevHtmlOv = html.style.overflow;
      const prevBodyOv = body.style.overflow;

      // html.style.height = "100%";
      // body.style.height = "100%";
      html.style.overflow = "hidden";
      // body.style.overflow = "hidden";

      return () => {
        html.style.height = prevHtmlH;
        body.style.height = prevBodyH;
        // html.style.overflow = prevHtmlOv;
        // body.style.overflow = prevBodyOv;
      };
    }
  }, []);
  const BOTTOM_HEIGHT = 140;
  const insets = useSafeAreaInsets();
  const isPortrait = height >= width;

  const routeName = useNavigationState(
    (state) => state.routes[state.index].name,
  );
  const isTournamentRoute =
    routeName === "Tournaments" ||
    routeName === "Tournament" ||
    routeName === "ActiveTournament";
  const isMobileLayout = !isDesktop;
  const backgroundSource = isTournamentRoute
    ? isMobileLayout
      ? BgTournamentMobile
      : BgTournament
    : isMobileLayout
      ? BgPortraitPng
      : BgLandscapePng;
  const [webInitialized, setWebInitialized] = useState(false);
  console.log("📍 current route:", routeName);

  const handleClosePaymentModal = () => {
    setShowPaymentModal(false);
  };

  const [servicesRecovering, setServicesRecovering] = useState({
    websocket: false,
    game: false,
  });

  useEffect(() => {
    if (!servicesRecovering.websocket && !servicesRecovering.game) {
      setShowRecoveryModal(false);
    } else {
      setShowRecoveryModal(true);
    }
  }, [servicesRecovering]);

  useEffect(() => {
    if (!playerId || !username) return;

    const socket = getSocket(String(playerId), String(username));
    const handleWebSocketRecovering = (event: any) => {
      console.log("WebSocket recovering:", event.detail);
      setServicesRecovering((prev) => ({ ...prev, websocket: true }));
    };

    const handleWebSocketReady = (event: any) => {
      console.log("WebSocket ready:", event.detail);
      setServicesRecovering((prev) => ({ ...prev, websocket: false }));
    };

    const handleGameRecovering = (data: any) => {
      console.log("Game recovering:", data);
      setServicesRecovering((prev) => ({ ...prev, game: true }));
    };

    const handleGameRecovered = (data: any) => {
      console.log("Game recovered:", data);
      setServicesRecovering((prev) => ({ ...prev, game: false }));
    };

    //  Game service health
    socket.on("game:recovering", handleGameRecovering);
    socket.on("game:recovered", handleGameRecovered);

    // window.addEventListener(
    //   "websocket:recovering",
    //   handleWebSocketRecovering as EventListener
    // );
    // window.addEventListener(
    //   "websocket:ready",
    //   handleWebSocketReady as EventListener
    // );

    return () => {
      socket.off("game:recovering", handleGameRecovering);
      socket.off("game:recovered", handleGameRecovered);
      // window.removeEventListener(
      //   "websocket:recovering",
      //   handleWebSocketRecovering as EventListener
      // );
      // window.removeEventListener(
      //   "websocket:ready",
      //   handleWebSocketReady as EventListener
      // );
    };
  }, [playerId, username]);

  const handleRetry = () => {
    if (!recoveryData || !playerId || !username) return;

    console.log("Retrying:", recoveryData);
    const socket = getSocket(String(playerId), String(username));

    if (recoveryData.tableId) {
      socket.emit("svara:getTable", { tableId: recoveryData.tableId });
    }
  };

  const handleCancelRecovery = () => {
    setShowRecoveryModal(false);
    setRecoveryData(null);
    navigation.navigate("Lobby" as never);
  };
  const rootStyle: ViewStyle =
    Platform.OS === "web"
      ? ({
          position: "absolute",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          minHeight: "100vh",
          overflow: "hidden",
          // backgroundColor: "#091426",
        } as unknown as ViewStyle)
      : {
          position: "absolute",
          top: 0,
          left: 0,
          width,
          height,
          bottom: 0,
          // backgroundColor: "#091426",
        };

  return (
    <View style={rootStyle}>
      <ImageBackground
        source={backgroundSource}
        style={[styles.full]}
        resizeMode="cover"
      >
        <StatusBar
          backgroundColor={theme.styles.container.backgroundColor}
          barStyle={dark ? "light-content" : "dark-content"}
        />

        <SafeAreaView style={[styles.full]} edges={["top"]}>
          {isSidebarOpen && (
            <Sidebar
              onClose={() => setIsSidebarOpen(false)}
              onOpenBonusGamesModal={() => {
                setIsBonusGamesModalOpen(true);
                setIsSidebarOpen(false);
              }}
            />
          )}
          {isBonusGamesModalOpen && (
            <BonusGamesModal onClose={() => setIsBonusGamesModalOpen(false)} />
          )}
          {/* Payment Status Modal */}
          {paymentData.status && (
            <PaymentStatusModal
              visible={showPaymentModal}
              status={paymentData.status}
              packageInfo={paymentData.packageInfo}
              onClose={handleClosePaymentModal}
              autoDismiss={true}
              // autoDismissDelay={5000}
            />
          )}
          <TopSection onOpenSidebar={() => setIsSidebarOpen(true)} />
          {/* {isPortrait || !isTallScreen ? (
            <ScrollView
              style={{ flex: 1 }}
              contentContainerStyle={{
                minHeight: contentMinHeight,
                paddingVertical: 10,
                paddingBottom: BOTTOM_HEIGHT,
              }}
            >
              {children}
            </ScrollView>
          ) : ( */}
          <View
            style={[
              {
                paddingVertical: 10,
                flex: 1,
                minHeight: 0,
              },
              Platform.OS !== "web" &&
                contentMinHeight != null && { minHeight: contentMinHeight },
            ]}
          >
            {children}
          </View>
          {/* )} */}
          {isAndroid ? (
            <View
              style={{
                position: "absolute",
                left: 0,
                right: 0,
                bottom: 14,
                paddingBottom: insets.bottom,
              }}
            >
              <BottomSection />
            </View>
          ) : (
            <BottomSection />
          )}
        </SafeAreaView>
      </ImageBackground>

      <GameRecoveryModal
        visible={showRecoveryModal}
        onRetry={handleRetry}
        onCancel={handleCancelRecovery}
        autoRetry={true}
        maxRetries={5}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  full: {
    flex: 1,

    // width: "100%",
    // height: "100%",
    // overflow: "hidden"
  },
});
